import { Box, Stack, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import remarkGfm from "remark-gfm";
import moment from "moment";
import { useMemo } from "react";

const Report = ({ user, report }) => {
  const parsedMessage = useMemo(
    () => <ReactMarkdown remarkPlugins={[remarkGfm]}>{report.markdown}</ReactMarkdown>,
    [report]
  );
  return (
    <Box className="report-wrapper">
      <Stack direction="row" sx={{ width: "100%" }}>
        <Box className="icon-box">
          <SummarizeOutlinedIcon sx={{ color: "#CA89F3", width: "24px", height: "24px" }} />
        </Box>
        <Stack flexGrow={1}>
          <Stack direction="row" alignItems="center">
            <Typography sx={{ fontWeight: 700, fontSize: "1rem" }}>Alysio Report</Typography>
            <Typography sx={{ fontWeight: 700, fontSize: "0.85rem", color: "#888", ml: "0.5rem" }}>
              {moment.tz(report.createdAt, user.timezone).format("M/D h:mma")}
            </Typography>
          </Stack>
          <Box className="markdown">{parsedMessage}</Box>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Report;
